import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { LanguageService, SiteContextConfig, StateWithSiteContext } from '@spartacus/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';

@Injectable()
export class CustomLanguageService extends LanguageService {
  protected cookieService = inject(SsrCookieService);
  protected override store = inject(Store<StateWithSiteContext>);
  protected override config = inject(SiteContextConfig);

  override setActive(isocode: string) {
    this.cookieService.set('lang', isocode);
    super.setActive(isocode);
  }
}
